import * as betgalaxy from './SavedCards.styles.betgalaxy';
import * as betprofessor from './SavedCards.styles.betprofessor';
import * as betroyale from './SavedCards.styles.betroyale';
import * as fiestabet from './SavedCards.styles.fiestabet';
import * as goldenrush from './SavedCards.styles.goldenrush';
import * as puntcity from './SavedCards.styles.puntcity';
import * as puntgenie from './SavedCards.styles.puntgenie';
import * as questbet from './SavedCards.styles.questbet';
import * as sterlingparker from './SavedCards.styles.sterlingparker';
import * as vikingbet from './SavedCards.styles.vikingbet';
import * as volcanobet from './SavedCards.styles.volcanobet';
import * as wellbet from './SavedCards.styles.wellbet';
import * as juicybet from './SavedCards.styles.juicybet';
import * as junglebet from './SavedCards.styles.junglebet';
import * as forsport from './SavedCards.styles.forsport';
import * as sugarcastle from './SavedCards.styles.sugarcastle';
import * as buffalobet from './SavedCards.styles.buffalobet';
import * as oldgill from './SavedCards.styles.oldgill';
import * as titanbet from './SavedCards.styles.titanbet';
import * as slambet from './SavedCards.styles.slambet';
import * as gigabet from './SavedCards.styles.gigabet';
import * as betstride from './SavedCards.styles.betstride';
import * as chromabet from './SavedCards.styles.chromabet';
import * as templebet from './SavedCards.styles.templebet';
import * as hyperbet from './SavedCards.styles.hyperbet';
import * as bet777 from './SavedCards.styles.bet777';
import * as epicodds from './SavedCards.styles.epicodds';
import * as magnumbet from './SavedCards.styles.magnumbet';
import { EThemesOG } from '@/constants/themeConfig';

export const styleImports: Partial<Record<EThemesOG, any>> = {
  oldgill,
  betgalaxy,
  betprofessor,
  betroyale,
  fiestabet,
  goldenrush,
  puntcity,
  puntgenie,
  questbet,
  sterlingparker,
  vikingbet,
  volcanobet,
  wellbet,
  juicybet,
  junglebet,
  forsport,
  sugarcastle,
  buffalobet,
  titanbet,
  slambet,
  gigabet,
  betstride,
  chromabet,
  templebet,
  hyperbet,
  bet777,
  epicodds,
  magnumbet,
};
